<footer class="footer" [ngClass]="{ hidden: isFooterHidden }">
  <div *ngIf="errorMessage" class="text-danger bold">
    {{ errorMessage }}
  </div>
</footer>
